export default {
  invoices: [],
}
